<template>
    <div v-if="additionals">
        <div v-if="model && additionals.salaVacinacaoLogada && !!additionals.salaVacinacaoLogada.id">
            <rkm-form
                ref="RkmFormEntrada"
                show-legend
            >
                <rkm-area
                    title="Dados da entrada"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-select
                                :disabled="(additionals && !additionals.salaVacinacaoLogada.responsavel)"
                                :options="form.unidades"
                                :validations="validations.unidadeId"
                                @change="handleUnidadeIdChange"
                                label="Unidade"
                                show-default-option
                                text-field="nomeFantasia"
                                v-model="model.unidadeId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-select
                                :disabled="!model.unidadeId || (additionals && !additionals.salaVacinacaoLogada.responsavel)"
                                :options="form.salasVacinacao"
                                :validations="validations.salaVacinacaoId"
                                label="Local de atendimento"
                                show-default-option
                                text-field="nome"
                                v-model="model.salaVacinacaoId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-date-picker
                                :disabled="!model.salaVacinacaoId || model.vacinas.length > 0"
                                :max-date="others.moment(additionals.dataAtual, 'YYYY-MM-DD').format('DD/MM/YYYY')"
                                :validations="validations.dataEntrada"
                                label="Data"
                                v-model="model.dataEntrada"
                            />
                        </rkm-col>

                        <rkm-col cols="8">
                            <rkm-form-input
                                :disabled="!model.salaVacinacaoId"
                                :validations="validations.origem"
                                label="Origem"
                                v-model="model.origem"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-form>

            <rkm-form ref="RkmFormVacina">
                <rkm-area
                    title="Vacina"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-input-autocomplete
                                :disabled="!model.dataEntrada"
                                :repository="repositories.vacina"
                                :request-query-string-params="{ registro: true }"
                                :search-fields="fields.autocomplete"
                                :text-field="item => item.id ? `${autocompleteTextField(item)}` : item.nome"
                                :validations="validations.vacinaId"
                                @select="handleVacinaIdSelect"
                                label="Vacina"
                                v-model="local.vacina"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-select
                                :disabled="!local.vacina"
                                :options="form.produtores"
                                :validations="validations.produtorId"
                                @change="handleProdutorIdChange"
                                label="Produtor"
                                show-default-option
                                text-field="nome"
                                v-model="local.produtorId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-select
                                :disabled="(local.vacina && local.vacina.codigo && !local.produtorId) || !local.vacina"
                                :options="form.apresentacoes"
                                :validations="validations.apresentacaoId"
                                @change="handleApresentacaoIdChange"
                                label="Apresentação"
                                show-default-option
                                text-field="nome"
                                v-model="local.apresentacaoId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="2">
                            <rkm-form-input
                                :disabled="!local.apresentacaoId"
                                :validations="validations.quantidade"
                                label="Quantidade"
                                type="number"
                                v-model="local.quantidade"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :disabled="!local.apresentacaoId"
                                :validations="validations.lote"
                                label="Lote"
                                uppercase
                                v-model="local.lote"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-date-picker
                                :disabled="!local.apresentacaoId"
                                :min-date="dataEntrada"
                                :validations="validations.dataValidadeLote"
                                label="Validade do lote"
                                v-model="local.dataValidadeLote"
                            />
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-button
                                :disabled="!local.apresentacaoId"
                                :label="false"
                                @click="handleInserirClick"
                                color="primary"
                            >
                                Incluir
                            </rkm-button>

                            <rkm-button
                                :disabled="!local.apresentacaoId"
                                :label="false"
                                @click="handleLimpar"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-table
                                :fields="fields.table"
                                :items="model.vacinas"
                                ref="RkmTableVacina"
                            >
                                <template v-slot:cell(actions)="{ index }">
                                    <rkm-button
                                        @click="handleDestroy(index)"
                                        color="danger"
                                        small
                                        title="Excluir"
                                    >
                                        <rkm-icon icon="trash" />
                                    </rkm-button>
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-form>
        </div>

        <rkm-alert v-else color="warning">
            A unidade logada não é uma sala de vacinação ou está desativada, favor cadastra-la para efetuar uma entrada.
        </rkm-alert>
    </div>
</template>

<script>
// Enums.
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'

// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        fields() {
            const autocomplete = []
            const table = []

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    autocomplete.push({ key: 'abreviacao', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    autocomplete.push({ key: 'sigla', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    autocomplete.push({ key: 'sigla', searchable: true })
                    autocomplete.push({ key: 'nome', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    autocomplete.push({ key: 'sigla', searchable: true })
                    autocomplete.push({ key: 'abreviacao', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    autocomplete.push({ key: 'abreviacao', searchable: true })
                    autocomplete.push({ key: 'nome', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    autocomplete.push({ key: 'sigla', searchable: true })
                    autocomplete.push({ key: 'abreviacao', searchable: true })
                    autocomplete.push({ key: 'nome', searchable: true })
                    break;

                default:
                    autocomplete.push({ key: 'nome', searchable: true })
                    break;
            }

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    table.push({ key: 'vacinaAbreviacao', label: 'Abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    table.push({ key: 'vacinaSigla', label: 'Sigla da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    table.push({ key: 'vacinaSiglaNome', label: 'Sigla e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    table.push({ key: 'vacinaSiglaAbreviacao', label: 'Sigla e abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    table.push({ key: 'vacinaAbreviacaoNome', label: 'Abreviação e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    table.push({ key: 'vacinaSiglaAbreviacaoNome', label: 'Sigla, abreviação e nome da vacina' })
                    break;

                default:
                    table.push({ key: 'vacinaNome', label: 'Nome da vacina' })
                    break;
            }

            table.push(
                { key: 'produtorNome', label: 'Produtor' },
                { key: 'apresentacaoNome', label: 'Apresentação' },
                { key: 'quantidade', label: 'Quantidade' },
                { key: 'lote', label: 'Lote' },
                { key: 'dataValidadeLote', label: 'Validade do lote' },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' }
            )

            return {
                autocomplete,
                table,
            }
        },
        validations() {
            return {
                unidadeId: { required: true },
                salaVacinacaoId: { required: true },
                dataEntrada: { required: true },
                origem: {
                    required: true,
                    min: 3,
                    max: 100,
                },
                vacinaId: { required: true },
                produtorId: { required: true },
                apresentacaoId: { required: true },
                quantidade: {
                    required: true,
                    min_value: 1,
                    max: 8,
                },
                lote: {
                    required: true,
                    max: 30,
                },
                dataValidadeLote: { required: true },
            }
        },
        dataEntrada() {
            return this.others.moment(this.model.dataEntrada).format('DD/MM/YYYY')
        },
    },
    created() {
        this.repositories = {
            entrada: this.getConectaSusRepository('imunizacao.entrada'),
            vacina: this.getConectaSusRepository('cadastro.vacina'),
        }
    },
    data: () => ({
        additionals: null,
        enums: { parametrizacaoDescricaoVacina },
        form: null,
        local: {
            vacina: null,
            produtorId: null,
            apresentacaoId: null,
            quantidade: null,
            lote: null,
            dataValidadeLote: null,
        },
        model: null,
        others: { moment },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            const request = { tipoMovimentacao: 'entrada' }

            this.setLoading()

            this.repositories.entrada.create(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                    this.$emit('loaded', { additionals: this.additionals })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUnidadeIdChange(id) {
            this.model.salaVacinacaoId = null

            const request = {
                listar: 'salas_vacinacao',
                unidadeId: id,
            }

            this.setLoading()

            this.repositories.entrada.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.salasVacinacao = Object.assign(response.data)

                    if (this.form.salasVacinacao.length === 1) {
                        const selected = this.form.salasVacinacao[0]
                        this.model.salaVacinacaoId = selected.id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleVacinaIdSelect(value) {
            this.local.produtorId = null
            this.local.apresentacaoId = null
            this.local.quantidade = null
            this.local.lote = null
            this.local.dataValidadeLote = null

            if (value.codigo) {
                const request = {
                    listar: 'produtores',
                    vacinaId: value.id,
                }

                this.setLoading()

                this.repositories.entrada.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.produtores = Object.assign(response.data)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                const request = {
                    listar: 'produtores_e_apresentacoes',
                }

                this.setLoading()

                this.repositories.entrada.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.produtores = Object.assign(response.data.produtores)
                        this.form.apresentacoes = Object.assign(response.data.apresentacoes)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleProdutorIdChange(id) {
            this.local.apresentacaoId = null
            this.local.quantidade = null
            this.local.lote = null
            this.local.dataValidadeLote = null

            if (this.local.vacina.codigo) {
                const request = {
                    listar: 'apresentacoes',
                    vacinaId: this.local.vacina.id,
                    produtorId: id,
                }

                this.setLoading()

                this.repositories.entrada.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.apresentacoes = Object.assign(response.data)

                        if (this.form.apresentacoes.length === 1) {
                            const selected = this.form.apresentacoes[0]
                            this.local.apresentacaoId = selected.id
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleApresentacaoIdChange() {
            this.local.quantidade = null
            this.local.lote = null
            this.local.dataValidadeLote = null
        },
        handleInserirClick() {
            this.$refs.RkmFormVacina.validate()
                .then(valid => {
                    if (valid === false) return

                    const produtor = this.form.produtores.find(produtor => produtor.id === this.local.produtorId)
                    const apresentacao = this.form.apresentacoes.find(apresentacao => apresentacao.id === this.local.apresentacaoId)

                    const vacina = {
                        vacinaId: this.local.vacina.id,
                        vacinaNome: this.local.vacina.nome,
                        vacinaAbreviacao: this.local.vacina.abreviacao,
                        vacinaSigla: this.local.vacina.sigla,
                        vacinaSiglaNome: `${this.local.vacina.sigla} - ${this.local.vacina.nome}`,
                        vacinaSiglaAbreviacao: `${this.local.vacina.sigla} - ${this.local.vacina.abreviacao}`,
                        vacinaAbreviacaoNome: `${this.local.vacina.abreviacao} - ${this.local.vacina.nome}`,
                        vacinaSiglaAbreviacaoNome: `${this.local.vacina.sigla} - ${this.local.vacina.abreviacao} -
                            ${this.local.vacina.nome}`,
                        produtorId: produtor.id,
                        produtorNome: produtor.nome,
                        apresentacaoId: apresentacao.id,
                        apresentacaoNome: apresentacao.nome,
                        quantidade: Number(this.local.quantidade),
                        lote: this.local.lote,
                        dataValidadeLote: this.others.moment(this.local.dataValidadeLote).format('DD/MM/YYYY'),
                    }

                    this.model.vacinas.push(vacina)
                    this.resetRkmFormVacina()
                })
        },
        handleLimpar() {
            this.resetRkmFormVacina()
        },
        resetRkmFormVacina() {
            this.local = {
                vacina: null,
                produtorId: null,
                apresentacaoId: null,
                quantidade: null,
                lote: null,
                dataValidadeLote: null,
            }

            this.$refs.RkmFormVacina.resetValidator()
        },
        handleDestroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir a vacina?', async () => this.model.vacinas.splice(index, 1))
        },
        save() {
            this.$refs.RkmFormEntrada.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.vacinas.length === 0) {
                        this.showValidationNotification('Obrigatório incluir pelo menos uma vacina.')
                        return
                    }

                    this.setLoading()

                    const request = {
                        tipoMovimentacao: 'entrada',
                        salaVacinacaoId: this.model.salaVacinacaoId,
                        dataEntrada: this.others.moment(this.model.dataEntrada).format('DD/MM/YYYY'),
                        origem: this.model.origem,
                        vacinas: this.model.vacinas.map(vacina => {
                            return {
                                vacinaId: vacina.vacinaId,
                                produtorId: vacina.produtorId,
                                apresentacaoId: vacina.apresentacaoId,
                                quantidade: vacina.quantidade,
                                lote: vacina.lote,
                                dataValidadeLote: vacina.dataValidadeLote,
                            }
                        }),
                    }

                    this.repositories.entrada.store(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.showSaveNotification()
                            this.$emit('save', response)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        autocompleteTextField(item) {

            let textField = null

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    textField = `${item.abreviacao}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    textField = `${item.sigla}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    textField = `${item.sigla} - ${item.nome}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    textField = `${item.sigla} - ${item.abreviacao}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    textField = `${item.abreviacao} - ${item.nome}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    textField = `${item.sigla} - ${item.abreviacao} - ${item.nome}`
                    break;

                default:
                    textField = `${item.nome}`
                    break;
            }

            return textField
        },
    },
    mixins: [ error, repository, stringCase ],
    mounted() {
        this.load()
    },
}
</script>